export function visibleGraphQLPins(sessions, pins, deleted, teammates = []) {
    const artifactPins = pins.filter((pin) => pin.kind === 'artifact');
    return [
        ...sessions
            .filter((item) => !deleted.has(item.uuid))
            .map((item) => ({
            kind: 'session',
            item,
            pinnedAt: item.pinned_at,
            pinKind: item.sidebarItemType === 'automation' ? 'automation' : 'thread',
            id: item.sidebarItemType === 'automation'
                ? item.automationId
                : (item.context_uuid ?? item.uuid),
        })),
        ...teammates.map((pin) => ({
            kind: 'teammate',
            pin,
            pinnedAt: pin.pinned_at,
            pinKind: 'thread',
            id: pin.node.contextUUID ?? pin.node.id,
        })),
        ...artifactPins.map((pin) => ({
            kind: 'artifact',
            pin,
            pinnedAt: pin.pinned_at,
            pinKind: 'file',
            id: pin.artifact.asset_id,
        })),
    ]
        .sort((a, b) => {
        if ((a.kind === 'teammate') !== (b.kind === 'teammate'))
            return a.kind === 'teammate' ? -1 : 1;
        const timeOrder = (Date.parse(b.pinnedAt ?? '') || 0) - (Date.parse(a.pinnedAt ?? '') || 0);
        if (timeOrder)
            return timeOrder;
        if (a.pinKind !== b.pinKind)
            return a.pinKind < b.pinKind ? 1 : -1;
        return a.id < b.id ? 1 : a.id > b.id ? -1 : 0;
    })
        .slice(0, 50);
}
//# sourceMappingURL=graphQLPinnedRows.js.map